module.exports = __webpack_public_path__ + "img/stores.30ee539a.svg";